

import React, { useEffect, useRef } from 'react';
import ModalWrapper from '../../../../UI/ModalWrapper';
import DailyIframe from '@daily-co/daily-js';
import { ToastContainer } from 'react-toastify';

function VideoJoinModalClient({ onCloseModal, videoLink }) {
    const callFrameRef = useRef(null);
    const callFrameInstance = useRef(null);
// console.log(onCloseModal);

    useEffect(() => {
        if (videoLink && callFrameRef.current) {
            // Always create a new call frame
            const callFrame = DailyIframe.createFrame({
                iframeStyle: {
                    width: '100%',
                    height: '95vh',
                    border: '0',
                    borderRadius: '0px'
                },
                showLeaveButton: true,
                  allowMultipleCallInstances: true 
            });

           
            callFrame.on('left-meeting', () => {
    // Remove the iframe from the DOM
   
    onCloseModal();
});

           
            callFrameRef.current.innerHTML = '';
            callFrameRef.current.appendChild(callFrame.iframe());
 callFrame.join({ url: videoLink });
            // Store the instance for cleanup
            callFrameInstance.current = callFrame;

            // Cleanup: leave and destroy the call frame
            return () => {
                if (callFrameInstance.current) {
                    callFrameInstance.current.leave();
                    callFrameInstance.current.destroy();
                    callFrameInstance.current = null;
                }
                if (callFrameRef.current) {
                    callFrameRef.current.innerHTML = '';
                }
            };
        }
    }, [videoLink, onCloseModal]);

    return (
        <ModalWrapper>
            <ToastContainer />
            <div className="bg-white rounded-3xl text-xl font-ubuntu px-6 py-6 w-[90%]">
                <div className="flex justify-between items-center mb-4">
                    <span className="font-semibold text-lg">Live Video Call</span>
                    <button onClick={onCloseModal} className="text-red-500 font-semibold">Close</button>
                </div>
                <div ref={callFrameRef} />
            </div>
        </ModalWrapper>
    );
}

export default VideoJoinModalClient;


